import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import axios from "axios";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";


// Setup Axios Base URL dynamically for mobile support if env not set
if (process.env.REACT_APP_API_BASE_URL) {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
} else {
  // If accessing from localhost/127.0.0.1, assume backend is on same host default port 4000
  // If accessing from network IP (mobile), use that IP
  const hostname = window.location.hostname;
  axios.defaults.baseURL = `http://${hostname}:4000`;
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <Provider store={store}>
      <ErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ErrorBoundary>
    </Provider>
  </HelmetProvider>
);
